/**
 * Canonical store mock for GET /me endpoint
 */
export const storeMock = {
  destinationId: '001',
  storeName: 'Rezolve AI Store',
  projectId: '1111111-2222-3333-4444-555555555555',
  lastUpdateTime: '2020-10-01T01:00:00.000Z',
  waitTime: {
    alert: 300,
    goal: 400,
  },
}
